import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { CloseFooter } from '@/dialogs/common/closeFooter'
import { BsrsGrid, NameColumn } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'

function OutputReportSourcesDialog (props) {
  const { outputReportSources } = props
  const { localize, locale } = useLocalization()

  return <React.Fragment><BasicHeader title='Reporting.SourceReports' {...props} />
    <ModalBody {...props}>
      <BsrsGrid items={outputReportSources} disableExcelExport>
        {NameColumn({ locale, nameProp: 'name', latinNameProp: 'latinName', title: localize('Common.Name'), editable: false })}
        <Column field='datasetNumber' title={localize('Common.DatasetNumber')} />
      </BsrsGrid>
    </ModalBody>
    <CloseFooter btnColor='secondary' {...props} />
  </React.Fragment>
}

export default {
  modalProps: {
    className: 'modal-dialog--lg'
  },
  component: OutputReportSourcesDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/outputReportSources.js